import { render, staticRenderFns } from "./flit2go-payments.vue?vue&type=template&id=2a977180"
import script from "./flit2go-payments.vue?vue&type=script&lang=js"
export * from "./flit2go-payments.vue?vue&type=script&lang=js"
import style0 from "./flit2go-payments.vue?vue&type=style&index=0&id=2a977180&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports